import config from "../config";

const CATEGORY_CHECKLIST_API_URL = config.api.endpoints.CHECKLIST_DATA;
const CHECKLIST_TOPIC_STATUS_API_URL = config.api.endpoints.CHECKLIST_TOPIC_STATUS;

/**
 * Fetch checklists data from API
 */
export const fetchChecklists = async (token?: string) => {
  try {
    const response = await fetch(CATEGORY_CHECKLIST_API_URL, {
      method: "GET",
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    if (!response.ok) {
      throw new Error(`Failed to fetch checklists: ${response.status} ${response.statusText}`);
    }
    return await response.json();
  } catch (error) {
    console.error("Error while fetching checklists:", error);
    return [];
  }
};

/**
 * Fetch checklist topic status from API
 */
export const fetchChecklistTopicStatus = async (token?: string) => {
  try {
    const response = await fetch(CHECKLIST_TOPIC_STATUS_API_URL, {
      method: "GET",
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    if (!response.ok) {
      throw new Error(`Failed to fetch checklist topic status: ${response.status} ${response.statusText}`);
    }
    return await response.json();
  } catch (error) {
    console.error("Error while fetching checklist topic status:", error);
    return [];
  }
};
/**
 * Update/Toggle checklist topic status 
 */
export const markChecklistAsRead = async (token: string, checklistId: Number, status: string) => {
  const numericChecklistId = Number(checklistId);
  console.log("Services payload:", { checklistId: numericChecklistId, status });

  try {
    const response = await fetch(CATEGORY_CHECKLIST_API_URL, {
      method: "PUT", 
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        checklistId: numericChecklistId, 
        status,
      }),
    });
    
    if (!response.ok) {
      throw new Error(`Failed to update checklist status: ${response.status} ${response.statusText}`);
    }
    return await response.json();
  } catch (error) {
    console.error("Error marking checklist as read:", error);
    throw error;
  }
};
